import { ExtractionSourceTypeEnum } from '@aksia/enums';

export const EXTRACTION_HUB_IDS = {
  [ExtractionSourceTypeEnum.Email]: 'Extractions_DataTeamEmail',
  [ExtractionSourceTypeEnum.EmailAttachment]: 'Extractions_Document',
  [ExtractionSourceTypeEnum.ClientOpsAttachment]: 'Extractions_SecFiling',
  [ExtractionSourceTypeEnum.ClientOps]: 'Extractions_MonitoringEmail',
} as const satisfies Partial<Record<ExtractionSourceTypeEnum, string>>;
